import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "390",
  height: "71",
  viewBox: "0 0 390 71",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M0 70.8418V0.501709H390V70.8418C331.16 65.8201 264.975 63.0001 195 63.0001C125.025 63.0001 58.8398 65.8201 0 70.8418Z" }, null, -1)
  ])))
}
export default { render: render }